export { default as BoletaSalida } from './BoletaRecepcionSalida'
